import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Menu, X, GitCompare, LogOut, LayoutDashboard, ShieldCheck } from "lucide-react";
import { BrandLogo } from "@/components/BrandLogo";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

const NAV = [
  { label: "Véhicules", path: "/cars" },
  { label: "Agences", path: "/agencies" },
];

export const Header = () => {
  const { user, logout, compare } = useAuth();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const loc = useLocation();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-slate-200/70 bg-white/85 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          <Link to="/" data-testid="nav-brand-logo" className="flex items-center gap-2 group">
            <BrandLogo className="h-11" />
            <span className="ml-1 hidden sm:inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider" style={{ background: "#F0FDF4", color: "#006233" }}>
              Maroc
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {NAV.map((n) => (
              <Link
                key={n.path}
                to={n.path}
                data-testid={`nav-link-${n.path.slice(1)}`}
                className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors ${
                  loc.pathname === n.path ? "text-slate-900 bg-slate-100" : "text-slate-600 hover:text-slate-900 hover:bg-slate-50"
                }`}
              >
                {n.label}
              </Link>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-2">
            <Link to="/compare" data-testid="comparison-drawer-btn" className="relative p-2 text-slate-600 hover:text-slate-900">
              <GitCompare className="h-5 w-5" />
              {compare.length > 0 && (
                <span className="absolute -top-0.5 -right-0.5 flex h-4 w-4 items-center justify-center rounded-full text-[10px] font-bold text-white" style={{ background: "#C1272D" }}>
                  {compare.length}
                </span>
              )}
            </Link>
            {user ? (
              <>
                {(user.role === "admin" || user.is_admin) && (
                  <Button variant="ghost" size="sm" onClick={() => navigate("/admin")} data-testid="nav-admin-btn">
                    <ShieldCheck className="h-4 w-4 mr-1.5" /> Admin
                  </Button>
                )}
                {user.role !== "admin" && user.role !== "client" && (
                <Button variant="ghost" size="sm" onClick={() => navigate("/owner")} data-testid="nav-dashboard-btn">
                  <LayoutDashboard className="h-4 w-4 mr-1.5" /> Mon espace
                </Button>
                )}
                {user.role === "client" && (
                  <span className="text-sm text-slate-600 px-2" data-testid="nav-client-name">Bonjour, {user.full_name?.split(" ")[0]}</span>
                )}
                <Button variant="outline" size="sm" onClick={handleLogout} data-testid="nav-logout-btn">
                  <LogOut className="h-4 w-4" />
                </Button>
              </>
            ) : (
              <>
                <Button variant="ghost" size="sm" onClick={() => navigate("/login")} data-testid="nav-login-btn">
                  Connexion Pro
                </Button>
                <Button
                  size="sm"
                  onClick={() => navigate("/register")}
                  data-testid="nav-register-agency-btn"
                  className="text-white"
                  style={{ background: "#006233" }}
                >
                  Publier mon agence
                </Button>
              </>
            )}
          </div>

          <button className="md:hidden p-2" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-slate-200 bg-white px-4 py-4 space-y-2">
          {NAV.map((n) => (
            <Link key={n.path} to={n.path} onClick={() => setOpen(false)} className="block py-2 text-slate-700 font-medium">
              {n.label}
            </Link>
          ))}
          <Link to="/compare" onClick={() => setOpen(false)} className="block py-2 text-slate-700 font-medium">
            Comparer ({compare.length})
          </Link>
          <div className="pt-2 flex gap-2">
            {user ? (
              <>
                <Button className="flex-1" variant="outline" onClick={() => { setOpen(false); navigate("/owner"); }}>Mon espace</Button>
                <Button className="flex-1" variant="ghost" onClick={handleLogout}>Déconnexion</Button>
              </>
            ) : (
              <>
                <Button className="flex-1" variant="outline" onClick={() => { setOpen(false); navigate("/login"); }}>Connexion</Button>
                <Button className="flex-1 text-white" style={{ background: "#006233" }} onClick={() => { setOpen(false); navigate("/register"); }}>Mon agence</Button>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
};
